import '../components/product-atc.js';
import VariantSelector from '../modules/variant-selector.js';
import onDocumentReady from '../utils/on-document-ready.js';
import '../components/gorgias-chat.js';
import KlaviyoBackInStock from '../components/klaviyo-back-in-stock.js';

onDocumentReady(() => {
  const variantSelector = document.querySelector('[data-variant-selector]');
  const initialSelector = new VariantSelector(variantSelector);

  if (variantSelector) {
    initialSelector.loadInInitialVariant();
  }

  KlaviyoBackInStock();
});

// Re-initialise the size guide trigger
if (window.oz && window.oz.initTriggers) {
  window.oz.initTriggers([document.querySelector('[data-oz-trigger]')]);
}

document.addEventListener('section:product-info:reload', () => {
  const variantSelector = document.querySelector('[data-variant-selector]');

  if (variantSelector) {
    // eslint-disable-next-line no-new
    new VariantSelector(document.querySelector('[data-variant-selector]'));
  }

  // Re-initialise the size guide trigger
  if (window.oz && window.oz.initTriggers) {
    window.oz.initTriggers([document.querySelector('[data-oz-trigger]')]);
  }

  KlaviyoBackInStock();
});
